export default "__VITE_ASSET__8zNhtWFBOfAe3WuL7mg5Ig__";